<template>
  <header class="header">
    <div class="content-wrapper">
      <Logo class="logo" />
      <div class="buttons">
        <p class="number">+375 44 722-88-33</p>
        <Button class="header-button" @click.stop="openCallRequestModal"
          >Обратный звонок</Button
        >
        <Button class="header-button" variant="outline" @click.stop="clickLogIn"
          >Войти</Button
        >
      </div>
      <Burger />
    </div>
  </header>
</template>

<script>
import Button from "./Button.vue";
import Logo from "@/assets/icons/new-logo.svg";
import Burger from "./Burger.vue";
import LoginModal from "@/components/homePage/LoginModal.vue";
import { LoginModalProperties } from "@/utils/modalsProperties";
import { purchasesPath } from "@/router/purchases";
import CallRequestModal from "@/components/homePage/CallRequestModal.vue";
import { CallRequestModalProperties } from "@/utils/modalsProperties";
import { mapGetters } from "vuex";

export default {
  name: "Header",
  components: { Button, Logo, Burger },
  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
  },
  methods: {
    openLoginModal() {
      this.$modal.show(LoginModal, null, LoginModalProperties);
    },

    clickLogIn() {
      this.isAuthenticated
        ? this.$router.push(purchasesPath)
        : this.openLoginModal();
    },

    openCallRequestModal() {
      this.$modal.show(CallRequestModal, null, CallRequestModalProperties);
    },
  },
};
</script>

<style scoped lang="less">
.header {
  width: 100%;
  height: 160px;
  background-color: #484e55;
  @media (max-width: 1480px) {
    padding: 0 20px;
  }
  @media (max-width: 1439px) {
    height: 122px;
  }
  @media (max-width: 767px) {
    height: 88px;
    padding: 0 10px;
    position: fixed;
    top: 0;
    z-index: 99;
  }

  .content-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 1440px;
    width: 100%;
    height: 100%;
    margin: 0 auto;

    .logo {
      width: 168px;
      height: 80px;
      @media (max-width: 1439px) {
        width: 120px;
        height: 58px;
      }
      @media (max-width: 767px) {
        width: 80px;
        height: 38px;
      }
    }

    .buttons {
      display: flex;
      width: max-content;
      height: 100%;
      align-items: center;
      gap: 24px;

      .number {
        color: #ffffff;
        font-family: "Montserrat", sans-serif;
        font-weight: 500;
        font-size: 20px;
        line-height: 1;
        text-align: center;
        @media (max-width: 1439px) {
          display: none;
        }
      }
      .header-button {
        width: 300px;
        @media (max-width: 1439px) {
          height: 40px;
          width: 200px;
        }
        @media (max-width: 767px) {
          display: none;
        }
      }
    }
  }
}
</style>
